import { defineStore } from 'pinia'

const expiryDate = new Date()
expiryDate.setHours(23, 59, 59, 999)

export const useCampaignsStore = defineStore('campaigns', {
	namespaced: true,
	state: () => ({
		// Campaigns
		campaigns: {},
		campaignsStatus: {},
		primaryCampaignKey: null,
		secondaryCampaignKey: null,

		// Novated Lease Promo
		novatedLeasePromo: {
			isPreselected: false,
		},

		isLoading: false,
	}),
	getters: {
		showCampaignStatus: (state) => (campaignName) => {
			const campaignStatus = state.campaignsStatus[campaignName]
			return campaignStatus
		},

		getPrimaryCampaignKey: (state) => {
			return state.primaryCampaignKey
		},

		getSecondaryCampaignKey: (state) => {
			return state.secondaryCampaignKey
		},

		isNovatedLeasePreselected: (state) =>
			state.novatedLeasePromo.isPreselected,

		hasAnyCampaignsActive: (state) => {
			return Object.keys(state.campaigns ?? {}).length > 0
		},
	},
	actions: {
		checkCampaignStatus() {
			this.isLoading = true

			this.campaignsStatus = {}

			Object.keys(this.campaigns).forEach((campaignName) => {
				const campaign = this.campaigns[campaignName]
				const isActive = isCampaignActive(
					campaign.start_date,
					campaign.end_date
				)
				this.campaignsStatus[campaignName] = isActive
			})

			setPrimaryCampaignKey()
			setSecondaryCampaignKey()

			if (import.meta.client) {
				if (
					this.primaryCampaignKey &&
					this.campaignsStatus[this.primaryCampaignKey] === true
				) {
					// Initialize or read the cookie if needed
					useCookie('campaigns')
				} else {
					// Reset the cookie if the primary key doesn't exist or isn't active
					const campaignCookie = useCookie('campaigns')
					campaignCookie.value = null
				}

				refreshCookie('campaigns')

				nextTick(() => {
					this.isLoading = false
				})
			} else {
				this.isLoading = false
			}
		},

		completePreselection() {
			this.novatedLeasePromo.isPreselected = false
		},
	},
	persist: {
		pick: [
			'campaignsStatus',
			'novatedLeasePromo',
			'primaryCampaignKey',
			'secondaryCampaignKey',
		],

		storage: (() => {
			const cookies = piniaPluginPersistedstate.cookies({
				sameSite: 'strict',
				expires: expiryDate,
			})

			return {
				getItem: (key) => cookies.getItem(key),
				// Detached Pinia subscribe can run outside Nuxt context during SSR plugins.
				setItem: (key, value) => {
					try {
						cookies.setItem(key, value)
					} catch {
						// Skip cookie write when useCookie has no Nuxt instance.
					}
				},
			}
		})(),
	},
})
